var { getAuthorisationHeader } = require("./aws");
var { formattedNow } = require("./util");
var sha256 = require("crypto-js/sha256");

function getCredentials(identityId){
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open("POST", "https://www.totallymoney.com/cognito/");
    xmlHttp.setRequestHeader("x-amz-target", "AWSCognitoIdentityService.GetCredentialsForIdentity");
    xmlHttp.setRequestHeader("content-type", "application/x-amz-json-1.1");
    xmlHttp.send(JSON.stringify({IdentityId: identityId}));
    
    return new Promise(function (resolve, reject) {
      xmlHttp.onload = function () {
        if (xmlHttp.status >= 200 && xmlHttp.status < 300) {
          var response = JSON.parse(xmlHttp.responseText);
          resolve(response.Credentials);
        } else {
          reject({
            status: xmlHttp.status,
            statusText: xmlHttp.statusText
          });
        }
      };
    });
}

function putRecordBatch(deliveryStream, records, credentials) {

  records.forEach(function(item, index) {
    this[index].Data = btoa ? btoa(unescape(encodeURIComponent(item.Data))) : Buffer.from(item.Data, 'binary').toString('base64')
  }, records);
  
  var payload = JSON.stringify({
    DeliveryStreamName: deliveryStream,
    Records: records
  });
  var now = formattedNow();

  var xmlHttp = new XMLHttpRequest();
  xmlHttp.open("POST", "https://firehose.eu-west-2.amazonaws.com/");
  xmlHttp.setRequestHeader("x-amz-content-sha256", sha256(payload).toString()),
  xmlHttp.setRequestHeader("x-amz-date", now),
  xmlHttp.setRequestHeader("x-amz-security-token", credentials.SessionToken);
  xmlHttp.setRequestHeader("x-amz-target", "Firehose_20150804.PutRecordBatch");
  xmlHttp.setRequestHeader("x-amz-user-agent", "aws-sdk-js/2.606.0 promise");
  xmlHttp.setRequestHeader("content-type", "application/x-amz-json-1.1");


  var authorisationHeader = getAuthorisationHeader(
    credentials.AccessKeyId, 
    credentials.SecretKey,
    "POST",
    "/",
    "",
    [
      ["host", "firehose.eu-west-2.amazonaws.com"],
      ["x-amz-content-sha256", sha256(payload).toString()],
      ["x-amz-date", now],
      ["x-amz-security-token", credentials.SessionToken],
      ["x-amz-target", "Firehose_20150804.PutRecordBatch"],
      ["x-amz-user-agent", "aws-sdk-js/2.606.0 promise"],
    ],
    payload,
    now.substring(0, 8),
    now,
    "eu-west-2",
    "firehose"
  );

  xmlHttp.setRequestHeader("authorization", authorisationHeader);
  xmlHttp.send(payload);

  return new Promise(function (resolve, reject) {
    xmlHttp.onload = function () {
      if (xmlHttp.status >= 200 && xmlHttp.status < 300) {
        var response = JSON.parse(xmlHttp.responseText);
        resolve(response);
      } else {
        reject({
          status: xmlHttp.status,
          statusText: xmlHttp.statusText
        });
      }
    };
  });
}

module.exports = {
  getCredentials,
  putRecordBatch
};